import * as React from 'react';
import Box from '@mui/material/Box';
import PrimaryTab from './PrimaryTab';
import PrimaryTabs from './PrimaryTabs';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

interface PanelTabsProps {
  children?: React.ReactNode;
  label: string;
  disabled?: boolean;
}

interface PanelTabsWrapperProps {
  children: React.ReactElement | Array<React.ReactElement>;
  handleTabChange?: (tab_number: number) => void;
  /** When provided, the active tab is controlled by the parent (keep it in sync via handleTabChange). */
  activeTab?: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tabpanel-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 4 }}>{children}</Box>}
    </div>
  );
}

const PanelTabsWrapper = (props: PanelTabsWrapperProps) => {
  const { children, handleTabChange, activeTab } = props;
  const [internalValue, setInternalValue] = React.useState(0);
  const value = activeTab ?? internalValue;

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    handleTabChange && handleTabChange(newValue);
    setInternalValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <PrimaryTabs value={value} onChange={handleChange} aria-label="tabs">
        {React.Children.map(children, (child, index) => {
          return (
            <PrimaryTab label={child.props.label} disabled={child.props.disabled} key={index} />
          );
        })}
      </PrimaryTabs>
      {React.Children.map(children, (child: React.ReactElement, index) => {
        return (
          <TabPanel value={value} index={index}>
            {child}
          </TabPanel>
        );
      })}
    </Box>
  );
};

const PanelTabs = (props: PanelTabsProps) => {
  return <>{props.children}</>;
};

export { PanelTabsWrapper, PanelTabs };
